import fetchGzipFromR2AsJsonViaCfFunctions from '../../utilities/r2Fetch';
import countyNames from './countyNames.json';

export const fetchEpisodesData = async (name, year) => {
  const key = `${name.toLowerCase().split(" ").join("_")}_episodes_${year}.json.gzip`
  return await fetchGzipFromR2AsJsonViaCfFunctions(key);
}

export const fetchCountyNames = async (fips) => {
  return Object.fromEntries(Object.entries(countyNames).filter(([k]) => fips.includes(k)));
};
